import { useState } from "react"
import styles from "./tournament-card.module.css"
import { Link } from "react-router-dom"

export default function TournamentCard({ tournament }) {
  const [isHovered, setIsHovered] = useState(false)

  const getStatusColor = (status) => {
    switch (status) {
      case "registration_open":
        return styles.statusOpen
      case "registration_closed":
        return styles.statusClosed
      case "coming_soon":
        return styles.statusSoon
      default:
        return styles.statusOpen
    }
  }

  return (
    <div className={styles.card} onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      <div className={styles.imageContainer}>
        <img src={
          tournament.bannerImage && tournament.bannerImage !== "undefined"
            ? tournament.bannerImage
            : "/placeholder.webp"
        } alt={tournament.title} className={styles.image} />
        <div className={styles.overlay} />
        {tournament.featured && <div className={styles.featuredBadge}>Featured</div>}
        <div className={`${styles.statusBadge} ${getStatusColor(tournament.status)}`}>{tournament.status}</div>
      </div>

      <div className={styles.content}>
        <div className={styles.gameBadge}>{tournament.game}</div>
        <h3 className={styles.title}>{tournament.title}</h3>

        <div className={styles.info}>
          <div className={styles.infoRow}>
            <span className={styles.label}>Prize Pool:</span>
            <span className={styles.value}>{tournament.prizePool}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Entry Fee:</span>
            <span className={styles.value}>{tournament.registrationPrice === 0 ? "Free" : `₹${tournament.registrationPrice}`}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.label}>Max Players:</span>
            <span className={styles.value}>{tournament.maxPlayers}</span>
          </div>
          {tournament?.createdBy && (
          <>
            <div className={styles.infoRow}>
              <span className={styles.label}>Created By:</span>
              <span className={styles.value}>{tournament?.createdBy?.username}</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.label}>Email:</span>
              <span className={styles.value}>{tournament?.createdBy?.email}</span>
            </div>
          </>
        )}
        </div>



        <Link to={`/tournament/detail/${tournament._id}`}>
          <button className={styles.registerBtn}>Register Now</button>
        </Link>
      </div>
    </div>
  )
}
